import React from "react";
import { Page } from "../activities/AppPage";
import { API } from "../API";
import { OnboardingVisitId } from "../messages/ObjectIds";
import FinishOnboardingBeforeStaffingModal from "./FinishOnboardingBeforeStaffingModal";
import { AppModalProps } from "./Generic/AppModal/AppModal";

interface Props {
  visitId: OnboardingVisitId;
  api: API;
  onRequestNavigate: (page: Page) => void;
}

const initialModalState: AppModalProps = {
  type: "info",
  actions: [],
  title: "",
  isOpen: false,
};

export default function useOnboardingVisitEngagement(props: Props) {
  const [modalState, setModalState] = React.useState<AppModalProps>(initialModalState);
  const [isOnboardingModalOpen, setOnboardingModalOpen] = React.useState(false);

  const closeModal = () => {
    setModalState((prevState) => ({ ...prevState, isOpen: false }));
  };

  const setModalAsLoading = () => {
    setModalState((prevState) => ({ ...prevState, isLoading: true }));
  };

  const promptRequestVisit = () => {
    setOnboardingModalOpen(true);
  };

  const closeOnboardingModal = () => {
    setOnboardingModalOpen(false);
  };

  const promptRejectVisit = () => {
    setModalAsLoading();
    setOnboardingModalOpen(true);
  };

  const promptCallAgency = () => {
    setModalAsLoading();
    setOnboardingModalOpen(true);
  };

  const onboardingModalProps: React.ComponentProps<typeof FinishOnboardingBeforeStaffingModal> = {
    isOpen: isOnboardingModalOpen,
    onRequestClose: closeOnboardingModal,
    onClickFinishOnboarding: () => {
      closeOnboardingModal();
      props.onRequestNavigate({ type: "OnboardingActivity" });
    },
  };

  return {
    promptRequestVisit: promptRequestVisit,
    promptRejectVisit: promptRejectVisit,
    closeEngagementModal: closeModal,
    promptCallAgency: promptCallAgency,
    engagementModalState: modalState,
    onboardingModalProps: onboardingModalProps,
  };
}
